import React, { useEffect, useState } from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import { marfatiyaApiConfig } from "../config/apiConfig.js";
import {
  groupInfo,
  dataObject,
  popupInfo,
  validate,
  challanBiltyOriginalTableHeader,
  challanBiltyOriginalTableItems,
} from "../config/MarfatiyaConfig.js";
import { NEW_PRINT, SERVER_URL } from "../config/config";
import { Prompt } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import "./Form.css";
import "./TripForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import DatePicker from "react-datepicker";
import FormColumn from "./FormColumn.js";
import print from "print-js";
import { useLocation } from "react-router-dom";

const MarfatiyaForm = ({ sessionObject }) => {
  const [biltyPopupOpen, setBiltyPopupOpen] = useState(false);
  const [biltyPopupMsg, setBiltyPopupMsg] = useState("");
  const [checkCwbSubmitted, setcheckCwbSubmitted] = useState(false);
  const [bulkEnabled, setBulkEnabled] = useState(false);
  const [bulkDeliveryStatus, setBulkDeliveryStatus] = useState("");
  const [showBulkSave, setShowBulkSave] = useState(false);
  const [bulkPopupOpen, setBulkPopupOpen] = useState(false);
  const [bulkPopupMsg, setBulkPopupMsg] = useState("");

  let checkCwbResult = {};

  const location = useLocation();
  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    station_name: sessionObject.sessionVariables.branch_name,
    // login_user_id: String(sessionObject.sessionVariables.user_id),
    role_id: String(sessionObject.sessionVariables.role_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
  };

  const myForm = useForm(
    "Marfatiya",
    validate,
    { ...dataObject, ...variablesFromSession },
    marfatiyaApiConfig
  );

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  React.useEffect(() => {
    console.log("pagestate", myForm.pageState);
  });

  React.useEffect(() => {
    // console.log(myForm.pageState);
    const defaultTripNo = location.state ?? "";
    console.log(defaultTripNo);
    if (defaultTripNo != "") {
      myForm.setPageState((oldPageState) => ({
        ...oldPageState,
        trip_no: defaultTripNo,
      }));

      const fakeKey = { key: "Enter" };
      myForm.getPageOnKeyEnter(fakeKey, defaultTripNo);
    }
  }, []);

  const checkIfFieldAlreadyExists = (fieldKey, fieldValue, arrayToCheck) => {
    let dummyObject = {};
    for (let i = 0; i < arrayToCheck.length; i++) {
      dummyObject = arrayToCheck[i];
      if (fieldKey in dummyObject && dummyObject[fieldKey] == fieldValue) {
        return true;
      }
    }
    return false;
  };

  const checkVisibilityCondition = (fieldInfo) => {
    // console.log("field info", fieldInfo, myForm.pageState.role_id)

    return true;
  };

  const checkDisabledCondition = (fieldInfo) => {
    if (myForm.pageMode == "view") {
      return "disabled";
    } else if (
      myForm.pageMode == "edit" &&
      fieldInfo.name == "mf_date" &&
      myForm.pageState.role_id != 1
    ) {
      return "disabled";
    } else {
      return "";
    }
  };

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    // if (fieldInfoObject.name == "vehicle_no"){
    //   return {"limit": "10"};
    // }
    let additionalInfoObject = {};
    if (fieldInfoObject.name == "station_from_name") {
      additionalInfoObject.is_branch = true;
      // additionalInfoObject.pay_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    return null;
  };

  const linkBilty = async (e) => {
    const fYear_fetch = myForm.pageState.fyear_get_bilty;
    if (myForm.pageState["Bilty No"] == "" && e.key == "Enter") {
      myForm.makeFocusOnParticularField("delivery_on");
      return;
    }
    if (e.key == "Enter") {
      let flag = 0;
      if (
        myForm.pageState.bilty_type == "c" ||
        myForm.pageState.bilty_type == "C"
      ) {
        flag = 1;
      }
      let suffix = myForm.pageState.suffix;
      if (suffix == "") {
        suffix = "null";
      }
      const url =
        SERVER_URL +
        "/biltyget_bilty_for_marfatiya?bilty_no=" +
        myForm.pageState["Bilty No"] +
        "&branch_id=" +
        myForm.pageState.created_from +
        "&fyear=" +
        myForm.pageState.fyear_get_bilty +
        "&companyId=" +
        myForm.pageState.company_id;

      const response = await fetch(url);

      if (!response.ok) {
        myForm.setPageState({
          ...myForm.pageState,
          ["Bilty No"]: "",
        });
        const temp_error = await response.json();
        if ("detail" in temp_error) {
          myForm.setPreviousPageMode(myForm.pageMode);
          myForm.setPageMode("error");
          myForm.setPopupError(String(temp_error.detail));
        } else {
          myForm.setPreviousPageMode(myForm.pageMode);
          myForm.setPageMode("error");
          myForm.setPopupError("Invalid Bilty");
        }
        return;
      }

      const temp_response = await response.json();
      console.log("sss", temp_response);

      let updatedPageState = { ...myForm.pageState };
      if (temp_response.no_of_package) {
        updatedPageState.total_pkgs = temp_response.no_of_package;
      }

      if (
        temp_response.bilty_id &&
        !(updatedPageState.bilty_ids || []).some(
          (bilty) => bilty.bilty_id === temp_response.bilty_id
        )
      ) {
        updatedPageState.bilty_ids = [
          ...(updatedPageState.bilty_ids || []),
          temp_response,
        ];
      }

      myForm.setPageState({
        ...updatedPageState,
        ["Bilty No"]: "",
        suffix: "",
      });

      myForm.makeFocusOnParticularField("bilty_no");
    }
  };

  const handleDelete = async () => {
    const url = SERVER_URL + "/marfatiya/?mf_id=" + myForm.pageState.mf_id;
    const response = await fetch(url, { method: "DELETE" });

    if (!response.ok) {
      console.log("Not able to delete marfatiya");
      return;
    }

    const temp_response = await response.json();

    if (temp_response.success === true) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
    }
  };

  useEffect(() => {
    if (
      Array.isArray(myForm.pageState.bilty_info) &&
      myForm.pageState.bilty_info.length > 0
    ) {
      const existingIds = new Set(
        (myForm.pageState.bilty_ids || []).map((bilty) => bilty.bilty_id)
      );

      const newBilties = myForm.pageState.bilty_info
        .filter((bilty) => !existingIds.has(bilty.bilty_id))
        .map((bilty) => ({
          ...bilty,
          station_from: bilty.station_from_name,
          station_to: bilty.station_to_name,
        }));

      if (newBilties.length > 0) {
        myForm.setPageState((prevState) => ({
          ...prevState,
          bilty_ids: [...(prevState.bilty_ids || []), ...newBilties],
        }));
      }
    }
  }, [myForm.pageState.bilty_info]);

  useEffect(() => {
    if (Array.isArray(myForm.pageState.bilty_ids)) {
      const totalPkgs = myForm.pageState.bilty_ids.reduce(
        (sum, bilty) => sum + (parseInt(bilty.no_of_package) || 0),
        0
      );

      myForm.setPageState((prev) => ({
        ...prev,
        pkgs: String(totalPkgs),
      }));
    }
  }, [myForm.pageState.bilty_ids]);

  useEffect(() => {
    if (Array.isArray(myForm.pageState.bilty_ids)) {
      const totalTempo = myForm.pageState.bilty_ids.reduce((sum, bilty) => {
        return sum + (parseFloat(bilty.tempo_collection) || 0);
      }, 0);

      myForm.setPageStateByField("total_tempo_collection", String(totalTempo));
    }
  }, [myForm.pageState.bilty_ids]);

  const updateBiltyForMarfatiya = async (bilty, index) => {
    try {
      if (!bilty?.bilty_id) return;

      const params = new URLSearchParams({
        bilty_id: bilty.bilty_id,
        tempo_collection: bilty.tempo_collection || "",
      });

      const url =
        SERVER_URL +
        "/bilty/update_tempo_collection_and_delivery_status?" +
        params.toString();

      const resp = await fetch(url, {
        method: "POST",
        headers: { Accept: "application/json" },
      });

      if (!resp.ok) {
        throw new Error("Failed to update bilty");
      }

      const result = await resp.json();
      console.log("Bilty updated", result);

      const updatedBilties = myForm.pageState.bilty_ids.map((b) => {
        if (b.bilty_id === bilty.bilty_id) {
          return {
            ...b,
            isTempoSaved: Number(bilty.tempo_collection) > 0,
            checked: "0",
          };
        }
        return {
          ...b,
          checked: "0",
        };
      });

      myForm.setPageStateByField("bilty_ids", updatedBilties);

      setBiltyPopupMsg("Bilty updated successfully");
      setBiltyPopupOpen(true);
    } catch (err) {
      console.error(err);
      setBiltyPopupMsg("Failed to update bilty");
      setBiltyPopupOpen(true);
    }
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    if (isNaN(date)) return null;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const handlePrintCewb = async () => {
    myForm.setOverlay(true);
    const url = `${SERVER_URL}/ewb/get_cewb_print_json_for_maraftiya/?cewb_number=${myForm.pageState.cewb_no}`;

    try {
      let response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch CEWB data");
      }

      const jsonData = await response.json();
      jsonData.cewb_date = jsonData.cewb_date
        ? formatDateToDDMMYYYY(jsonData.cewb_date)
        : null;

      const modifiedData = jsonData.data.map((item, index) => ({
        ...item,
        sr_no: index + 1,
        ewb_date: item.ewb_date ? formatDateToDDMMYYYY(item.ewb_date) : null,
      }));

      jsonData.data = modifiedData;

      const printResponse = await fetch(
        `${NEW_PRINT}/bilty/print_table/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonData),
        }
      );

      if (!printResponse.ok) {
        throw new Error("Failed to print the table");
      }

      const blobData = await printResponse.blob();

      if (blobData.size === 0) {
        throw new Error("Blob is empty, cannot print");
      }

      const blobUrl = URL.createObjectURL(blobData);
      console.log("Blob URL created:", blobUrl);

      print({ printable: blobUrl, type: "pdf", showModal: false });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      myForm.setOverlay(false);
    }
  };

  useEffect(() => {
    if (
      Array.isArray(myForm.pageState.bilty_ids) &&
      myForm.pageState.bilty_ids.length > 0
    ) {
      const alreadyProcessed = myForm.pageState.bilty_ids.some(
        (b) => b.isTempoSaved !== undefined
      );

      if (alreadyProcessed) return;

      const updatedBilties = myForm.pageState.bilty_ids.map((bilty) => ({
        ...bilty,
        isTempoSaved: !(
          bilty.tempo_collection === null ||
          bilty.tempo_collection === "" ||
          Number(bilty.tempo_collection) <= 0
        ),
      }));

      myForm.setPageStateByField("bilty_ids", updatedBilties);
    }
  }, [myForm.pageState.bilty_ids]);

  useEffect(() => {
    if (!Array.isArray(myForm.pageState.bilty_ids)) {
      myForm.setPageStateByField("total_cewb", "");
      return;
    }

    const totalEway = myForm.pageState.bilty_ids.reduce((sum, bilty) => {
      const fromSavedMarfatiya = Array.isArray(bilty.eway_bill_info)
        ? bilty.eway_bill_info.length
        : 0;

      const fromFetchedBilty = Array.isArray(bilty.eway_info)
        ? bilty.eway_info.length
        : 0;

      return sum + fromSavedMarfatiya + fromFetchedBilty;
    }, 0);

    myForm.setPageStateByField("total_cewb", String(totalEway));
  }, [myForm.pageState.bilty_ids]);

  const getSelectAllValue = () => {
    for (let i = 0; i < myForm.pageState.bilty_ids.length; i++) {
      if (myForm.pageState.bilty_ids[i].checked != "1") {
        return false;
      }
    }
    return true;
  };

  const handleCheckboxChange = (e, item, idx) => {
    const rows = [...myForm.pageState.bilty_ids];

    rows[idx] = {
      ...rows[idx],
      checked: e.target.checked ? "1" : "0",
    };

    myForm.setPageStateByField("bilty_ids", rows);
  };

  const selectAll = () => {
    if (!Array.isArray(myForm.pageState.bilty_ids)) return;

    const updated = myForm.pageState.bilty_ids.map((b) => ({
      ...b,
      checked: "1",
    }));

    myForm.setPageStateByField("bilty_ids", updated);
  };

  const deselectAll = () => {
    if (!Array.isArray(myForm.pageState.bilty_ids)) return;

    const updated = myForm.pageState.bilty_ids.map((b) => ({
      ...b,
      checked: "0",
    }));

    myForm.setPageStateByField("bilty_ids", updated);
  };

  const getSelectedBiltyIds = () => {
    if (!Array.isArray(myForm.pageState.bilty_ids)) return [];

    return myForm.pageState.bilty_ids
      .filter((b) => b.checked === "1" && b.bilty_id)
      .map((b) => b.bilty_id);
  };

  const updateBulkDeliveryStatus = async () => {
    try {
      const selectedIds = getSelectedBiltyIds();

      if (selectedIds.length === 0) return;

      const url =
        SERVER_URL +
        `/bilty/update_bulk_delivery_status?delivery_status=${bulkDeliveryStatus}`;

      const resp = await fetch(url, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedIds),
      });

      if (!resp.ok) {
        throw new Error("Bulk update failed");
      }

      const result = await resp.json();

      const updated = myForm.pageState.bilty_ids.map((b) =>
        b.checked === "1"
          ? { ...b, delivery_status: bulkDeliveryStatus, checked: "0" }
          : { ...b, checked: "0" }
      );

      myForm.setPageStateByField("bilty_ids", updated);

      setBulkPopupMsg(`${result.message}`);
      setBulkPopupOpen(true);

      setBulkEnabled(false);
      setBulkDeliveryStatus("");
      setShowBulkSave(false);
    } catch (err) {
      console.error(err);
      setBulkPopupMsg("Failed to update bulk delivery status");
      setBulkPopupOpen(true);
    }
  };

  useEffect(() => {
    const selected = getSelectedBiltyIds();
    setBulkEnabled(selected.length > 0);
  }, [myForm.pageState.bilty_ids]);

  return (
    <div className="challan-form-container">
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      if (myForm.previousPageMode != "") {
                        myForm.setPageMode(myForm.previousPageMode);
                        myForm.setPreviousPageMode("");
                      } else {
                        myForm.setPageMode("write");
                      }
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          open={biltyPopupOpen}
          modal
          closeOnDocumentClick
          contentStyle={{ maxWidth: "400px", width: "90%" }}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                Bilty Update
                <a
                  className="pop-up-close btn"
                  onClick={() => {
                    setBiltyPopupOpen(false);
                    close();
                  }}
                >
                  &times;
                </a>
              </div>

              <div className="pop-up-content">{biltyPopupMsg}</div>

              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    setBiltyPopupOpen(false);
                    close();
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={checkCwbSubmitted}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                <div> Result of check EWB </div>
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              <div className="pop-up-content">
                Information:
                <br />
                <div className="pop-up-fields">
                  {Object.keys(checkCwbResult).map((key) => {
                    let obj = checkCwbResult[key];
                    return (
                      <div>
                        <div className="pop-up-field">
                          <div className="pop-up-field-label"> Bilty No: </div>
                          <div className="pop-up-field-value">
                            {" "}
                            {obj.bilty_no}{" "}
                          </div>
                        </div>
                        <div className="pop-up-field">
                          <div className="pop-up-field-label">
                            {" "}
                            EWay bill No:{" "}
                          </div>
                          <div className="pop-up-field-value">
                            {" "}
                            {obj.eway_bill_no}{" "}
                          </div>
                        </div>
                        <hr />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    setcheckCwbSubmitted(false);
                    close();
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      if (myForm.previousPageMode != "") {
                        myForm.setPageMode(myForm.previousPageMode);
                        myForm.setPreviousPageMode("");
                      } else {
                        myForm.setPageMode("write");
                      }
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          open={bulkPopupOpen}
          modal
          closeOnDocumentClick
          contentStyle={{ maxWidth: "400px", width: "90%" }}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                Delivery Status
                <a
                  className="pop-up-close btn"
                  onClick={() => {
                    setBulkPopupOpen(false);
                    close();
                  }}
                >
                  &times;
                </a>
              </div>

              <div className="pop-up-content">{bulkPopupMsg}</div>

              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    setBulkPopupOpen(false);
                    close();
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">Marfatiya</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title">
          <div className="form-row">
            <label className="form-label">Marfatiya No:</label>
            <input
              className="form-input"
              type="text"
              name="mf_no"
              placeholder=""
              value={myForm.pageState.mf_no}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.mf_no)
              }
              disabled={checkDisabledCondition({ name: "mf_no" })}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "mf_no")}
            />
            {myForm.internalValidationErrors["mf_no"] && (
              <p>{myForm.internalValidationErrors["mf_no"]}</p>
            )}
            {myForm.pageMode == "view" && (
              <>
                {checkVisibilityCondition({ name: "edit_button" }) && (
                  <button
                    onClick={() => {
                      myForm.setPageMode("edit");
                    }}
                  >
                    Edit
                  </button>
                )}
                <button
                  onClick={() => {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });
                    window.location.reload();
                    myForm.setPageMode("write");
                  }}
                >
                  Clear
                </button>
              </>
            )}
          </div>

          <div className="form-row">
            <label className="chform-label">Bilty No:</label>
            <input
              className="chform-input"
              type="text"
              name="Bilty No"
              placeholder=""
              value={myForm.pageState["Bilty No"] || myForm.pageState.bilty_no}
              onChange={myForm.handleChange}
              //   onKeyPress={(a) => {
              //     if (a.key == "Enter") {
              //       myForm.makeFocusOnParticularField("suffix");
              //     }
              //   }}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  // console.log("press", myForm.pageState["Bilty No"]);
                  if (myForm.pageState["Bilty No"]) {
                    myForm.getFyearsOnKeyEnter(
                      e,
                      "Bilty Inquiry",
                      myForm.pageState["Bilty No"]
                    );
                  } else {
                    myForm.makeFocusOnParticularField("vehicle_no");
                  }
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "bilty_no")}
            />
            <select
              className="chform-input "
              name="suffix"
              value={myForm.pageState.suffix}
              onChange={(e) => myForm.handleChangeForSelect(e, "suffix")}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault();
                  linkBilty(e);
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "suffix")}
            >
              {myForm.pageState.suffix_options.map((suff) => {
                return <option value={suff}> {suff} </option>;
              })}
            </select>
          </div>

          <div>
            <label className="form-label">Marfatiya Date:</label>
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={
                myForm.pageState.mf_date
                  ? new Date(myForm.pageState.mf_date)
                  : null
              }
              onChange={(date) => myForm.setPageStateByField("mf_date", date)}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "mf_date")}
              disabled={checkDisabledCondition({ name: "mf_date" })}
              // onKeyPress={(a) => {
              //   console.log("Here");
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularField("consignor_name");
              //   }
              // }}
            />
          </div>
          <div className="form-row">
            <label className="form-last_bilty">Last Marfatiya No:</label>
            <label className="form-last_bilty">
              {myForm.pageState.last_mf_no}
            </label>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            marginLeft: "10px",
          }}
        >
          {/* <button
            type="button"
            className="btn btn-primary"
            disabled={!bulkEnabled}
            onClick={() => {
              setBulkDeliveryStatus("");
              setShowBulkSave(false);
            }}
          >
            Bulk Update
          </button> */}

          {bulkEnabled && (
            <select
              value={bulkDeliveryStatus}
              onChange={(e) => {
                setBulkDeliveryStatus(e.target.value);
                setShowBulkSave(true);
              }}
              style={{ width: "110px", marginTop: "5px", height: "30px" }}
            >
              <option value="">Select Status</option>
              <option value="Delivered">Delivered</option>
              <option value="Pending">Pending</option>
            </select>
          )}

          {showBulkSave && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={updateBulkDeliveryStatus}
            >
              Save
            </button>
          )}
        </div>

        <div className="table-container">
          <DynamicViewTable
            checkBox={1}
            tableHeader={challanBiltyOriginalTableHeader}
            tableItems={challanBiltyOriginalTableItems}
            tableValues={myForm.pageState["bilty_ids"]}
            setPageStateByField={myForm.setPageStateByField}
            pageStateArray={myForm.pageState["bilty_ids"]}
            fieldMapping="bilty_ids"
            pageMode={myForm.pageMode}
            roleId={myForm.pageState.role_id}
            formName="Marfatiya"
            onSaveBiltyRow={updateBiltyForMarfatiya}
            getSelectAllValue={getSelectAllValue}
            selectAll={selectAll}
            deselectAll={deselectAll}
            handleCheckboxChange={handleCheckboxChange}
          />
        </div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
              title="Marfatiya"
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
              title="Marfatiya"
            />
          </div>
        </div>

        <div className="form-footer">
          <button
            onClick={(e) => {
              myForm.setServerPrintNeeded(true);
              myForm.handleSubmit(e);
            }}
            type="button"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "print_button")}
            className="btn btn-primary"
          >
            Print
          </button>
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          <button
            onClick={handleDelete}
            disabled={!myForm.pageState.mf_id}
            className="btn btn-primary"
          >
            Delete
          </button>

          {/* {myForm.pageState.status == "1" && ( */}
          <button
            onClick={async () => {
              try {
                myForm.setOverlay(true);

                const fyear = JSON.parse(
                  sessionStorage.getItem("financial_year_for_fetch")
                ).financial_year_for_fetch;

                const url =
                  `${SERVER_URL}/ewb/consolidated_for_marfatiya/` +
                  `?mf_no=${myForm.pageState.mf_no}` +
                  `&fyear=${fyear}` +
                  `&companyId=${myForm.pageState.company_id}` +
                  `&created_from=${sessionObject.sessionVariables.branch_id}`;

                const response = await fetch(url, {
                  method: "GET",
                  headers: {
                    accept: "application/json",
                  },
                });

                if (!response.ok) {
                  throw new Error("Failed to generate CWB");
                }

                const data = await response.json();

                if (data?.cewb_no) {
                  myForm.setPageStateByField("cewb_no", data.cewb_no);
                  myForm.setPageMode("submitted");
                } else {
                  myForm.setPageMode("error");
                  myForm.setPopupError(data?.detail || "No CEWB generated");
                }
              } catch (err) {
                console.error(err);
                myForm.setPageMode("error");
                myForm.setPopupError("Unable to generate CEWB");
              } finally {
                myForm.setOverlay(false);
              }
            }}
            className="btn btn-primary"
          >
            Generate CWB
          </button>

          {/* )} */}

          {/* {myForm.pageState.status == "1" && ( */}
          <button onClick={handlePrintCewb} className="btn btn-primary">
            Print CEWB
          </button>
          {/* )} */}
          {/* {myForm.pageState.status == "1" && ( */}
          <button
            onClick={async () => {
              const fYear_fetch = JSON.parse(
                sessionStorage.getItem("financial_year_for_fetch")
              ).financial_year_for_fetch;

              try {
                myForm.setOverlay(true);

                const url =
                  SERVER_URL +
                  "/ewb/canceled/" +
                  myForm.pageState.mf_no +
                  `?branch_id=${myForm.pageState.created_from}` +
                  `&direct_govt=${0}` +
                  "&fyear=" +
                  fYear_fetch +
                  "&companyId=" +
                  myForm.pageState.company_id;

                const resp = await fetch(url);

                if (!resp.ok) {
                  throw new Error("API returned status " + resp.status);
                }

                const data = await resp.json();
                checkCwbResult = data;
                console.log({ data });
                setcheckCwbSubmitted(true);
              } catch (err) {
                console.error("Check EWB failed:", err);
                myForm.setPageMode("error");
                myForm.setPopupError(
                  err?.message || "Unable to check EWB. Please try again."
                );
              } finally {
                myForm.setOverlay(false);
              }
            }}
            className="btn btn-primary"
          >
            Check EWB
          </button>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default MarfatiyaForm;
